module.exports = __webpack_public_path__ + "static/media/logo-tgle-blanco.c00d8cfd.png";